<template>
  <VNavigationDrawer
    v-model="_drawer"
    right
    :permanent="_drawer"
    :width="width"
    :height="height"
  >
    <VLayout
      fill-height
      column
      justify-start
      align-center
      ma-0
      pa-0
    >
      <VToolbar
        height="64"
        color="primary"
        dark
      >
        <VToolbarTitle>
          <span>Followup Messages</span>
        </VToolbarTitle>
        <VSpacer />
        <VBtn
          icon
          dark
          @click.prevent="onAddNewMessage"
        >
          <VIcon>
            add
          </VIcon>
        </VBtn>
      </VToolbar>
      <div class="expansion-panel">
        <VExpansionPanel
          v-model="panel"
          expand
        >
          <VExpansionPanelContent
            v-for="(item,i) in messages"
            :key="i"
          >
            <div
              slot="header"
              class="text-truncate"
            >
              {{ item.body }}
            </div>
            <VCard>
              <VCardText
                class="card-text"
              >
                <VTextarea
                  :value="messages[i].body"
                  :rules="rules.textAreaLimit"
                  solo
                  label="Message"
                  @change="setMessageBody($event, i)"
                />
              </VCardText>
              <VDivider inset />
              <VCardActions>
                <VSpacer />
                <VBtn
                  icon
                  small
                  :disabled="messages.length === 1"
                  @click.prevent="onDeleteMessage(i)"
                >
                  <VIcon>
                    delete_forever
                  </VIcon>
                </VBtn>
              </VCardActions>
            </VCard>
          </VExpansionPanelContent>
        </VExpansionPanel>
      </div>
    </VLayout>
  </VNavigationDrawer>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'FollowupMessageDrawer',
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 300
    },
    height: {
      type: Number,
      default: 600
    },
    ruleIndex: {
      type: Number,
      default: null
    },
    messages: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      panel: [true],
      rules: {
        textAreaLimit: [
          value => !!value || 'Required.',
          value => value.length <= 256 || 'Text should be less than or equal to 256 characters'
        ]
      }
    }
  },
  computed: {
    _drawer: {
      get () {
        return this.drawer
      },
      set (val) {
        this.$emit('update:drawer', val)
      }
    }
  },
  methods: {
    ...mapActions({
      updateRuleMessageByIndex: 'automation/updateRuleMessageByIndex',
      addRuleMessage: 'automation/addRuleMessage',
      deleteRuleMessage: 'automation/deleteRuleMessage'
    }),
    setMessageBody (value, index) {
      if (this.ruleIndex === 0 || this.rule) {
        this.updateRuleMessageByIndex({ ruleIndex: this.ruleIndex, messageIndex: index, value })
      } else {
        this.messages[index].body = value
      }
    },
    onAddNewMessage () {
      if (this.ruleIndex === 0 || this.ruleIndex) {
        this.addRuleMessage({ ruleIndex: this.ruleIndex, newMessageData: { body: '' } })
      } else {
        this.messages.unshift({ body: '' })
      }
      this.panel.unshift(true)
    },
    onDeleteMessage (index) {
      if (this.ruleIndex === 0 || this.ruleIndex) {
        this.deleteRuleMessage({ ruleIndex: this.ruleIndex, messageData: { id: this.messages[index].id } })
      } else {
        this.messages.splice(index, 1)
      }
    }
  }
}
</script>

<style scoped>
.expansion-panel {
  width: 100%;
}
.card-text {
  padding: 0px 10px 0px 10px;
}
</style>
